export default __webpack_public_path__ + "static/media/lupa.d679b8fa.svg";